import Joi from 'joi';
import imageWithMetaDataSchema from '@utils/validate/blocksSchemes/imageWithMetadataSchema';
const pageHeaderBlockScheam = Joi.object({
  type: Joi.string().valid('pageHeaderBlock').required(),
  code: Joi.string().allow('', null).required(),
  headerType: Joi.string().valid('simple', 'small', 'big').required(),
  headerData: Joi.object({
    header: Joi.string().allow('', null),
    subHeader: Joi.string().allow('', null),
    image: Joi.alternatives().try(Joi.string(), Joi.object(imageWithMetaDataSchema).unknown(true)).allow(null, ''),
    backgroundColor: Joi.string().allow('', null)
  }).required()
}).unknown(true);
export default pageHeaderBlockScheam;